import { GET_MSISDN_BALANCE_ENDPOINT } from '../endpoints';
import { authorizedRequest } from '../wrapper';

export const msisdnBalanceRequest = () => authorizedRequest(GET_MSISDN_BALANCE_ENDPOINT);
